export default "__VITE_ASSET__5MsUoxbihf6xMn1vygCl5g__"